/** My submissions (the applicant's list and form) and the per-revision downloads (plan F3). */
export default {
  mySubmissions: {
    title: 'My submissions',
    subtitle: 'Your plan submissions, their checks and the decisions on them.',
    empty: 'You have no submissions yet. Start with New submission.',
    back: 'Back to my submissions',
    formIntro: 'The submission is made in your name, using your account details.',
    applicantHint:
      'Your name and email come from your account. Add your firm and professional registration number if they apply.',
  },
  downloads: {
    title: 'Downloads',
    revision: 'Files of revision {{revision}}',
    none: 'No files for this revision yet.',
    derivedHint: 'The GeoPackage and the Shapefile exist only for a revision whose check passed.',
    cad_drawing: 'Original drawing',
    cleanup_original: 'Original drawing (before clean-up)',
    cleanup_changes: 'Clean-up change list',
    derived_gpkg: 'GeoPackage (.gpkg)',
    derived_shp: 'Shapefile (.zip)',
    download: 'Download',
    downloadLabel: 'Download {{name}}',
  },
} as const
